import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  addBiometricState,
  updateBiometricState,
  changeBiometricLoading,
  dispatch,
  setErrorMessage,
  setSuccessMessage,
} from "../redux";

export const addBiometricReport = async (formData) => {
  try {
    // Set Loading
    dispatch(changeBiometricLoading(true));

    // API Fetching
    const resp = await httpClient().post(
      ApiEndpoints.createClientReportBiometric,
      {
        ...formData,
      }
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addBiometricState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeBiometricLoading(false));
  }
};

export const updateBiometricReportByReportId = async (id, formData) => {
  try {
    // Set Loading
    dispatch(changeBiometricLoading(true));

    // API Fetching
    const resp = await httpClient().patch(
      ApiEndpoints.updateClientReportBiometricByReportId + "/" + id,
      {
        ...formData,
      }
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(updateBiometricState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeBiometricLoading(false));
  }
};
